import { createSelector } from 'reselect';

import { createAsyncAction, fetchAction } from 'src/redux/actions';
import { Action } from 'src/types/state';

import { EXITED_CODE_REVIEW, prefixed } from './actions';
import { getPullRequestSlice } from './selectors';

// Action Types
export const QUEUE = createAsyncAction(prefixed('QUEUE'));
export const SET_ASYNC_QUEUE_IN_PROGRESS = prefixed(
  'SET_ASYNC_QUEUE_IN_PROGRESS'
);
export const FETCH_PULL_REQUEST_QUEUE_STATUS = createAsyncAction(
  prefixed('FETCH_PULL_REQUEST_QUEUE_STATUS')
);

// Action Creators
export const setAsyncQueueInProgress = (isAsyncQueueInProgress: boolean) => ({
  type: SET_ASYNC_QUEUE_IN_PROGRESS,
  payload: isAsyncQueueInProgress,
});

export const fetchPullRequestQueueStatus = (pollingLink: string) =>
  fetchAction(FETCH_PULL_REQUEST_QUEUE_STATUS, {
    url: pollingLink,
  });

// Initial State (also used as type)
export type QueueState = {
  hadError: boolean;
  isAsyncQueueInProgress: boolean;
  isRequesting: boolean;
  lastErrorCode: string | null;
  lastErrorMessage: string | null;
};

export const queueInitialState: QueueState = {
  hadError: false,
  isAsyncQueueInProgress: false,
  isRequesting: false,
  lastErrorCode: null,
  lastErrorMessage: null,
};

// Selectors
export const getIsAsyncQueueInProgress = createSelector(
  getPullRequestSlice,
  state => state.queue.isAsyncQueueInProgress
);
export const getIsQueueErrored = createSelector(
  getPullRequestSlice,
  state => state.queue.hadError
);
export const getIsQueueRequesting = createSelector(
  getPullRequestSlice,
  state => state.queue.isRequesting
);
export const getQueueErrorCode = createSelector(
  getPullRequestSlice,
  state => state.queue.lastErrorCode
);
export const getQueueErrorMessage = createSelector(
  getPullRequestSlice,
  state => state.queue.lastErrorMessage
);

// Reducer
export const queueReducer = (
  state: typeof queueInitialState = queueInitialState,
  action: Action
) => {
  switch (action.type) {
    case QUEUE.REQUEST:
      return {
        ...state,
        isRequesting: true,
        hadError: false,
        lastErrorMessage: null,
      };
    case QUEUE.SUCCESS:
      return {
        ...queueInitialState,
      };
    case QUEUE.ERROR:
      return {
        ...state,
        isRequesting: false,
        hadError: true,
        lastErrorMessage: action.payload,
      };
    case SET_ASYNC_QUEUE_IN_PROGRESS:
      return {
        ...state,
        isAsyncQueueInProgress: action.payload,
      };
    case EXITED_CODE_REVIEW:
      return {
        ...queueInitialState,
      };
    default:
      return state;
  }
};
